import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { BaseComponentImpl } from "../types/implementations";
import { Building } from "../types/protocols";
import { useBuildComponentTypes } from "../contexts/BuildComponentTypesContext";
import { getBaseTypeIconPath } from "../Helpers/componentTypeIconUtils";
import "./ParentComponentCard.css";

export interface ParentComponentCardProps {
    component: BaseComponentImpl;
    building: Building;
    buildingKey: string;
}

const ParentComponentCard: React.FC<ParentComponentCardProps> = ({
    component,
    building,
    buildingKey,
}) => {
    const { getTranslation } = useBuildComponentTypes();
    const iconPath = getBaseTypeIconPath(component.type);

    return (
        <Link
            className="parent-component-card"
            to={`/building/${buildingKey}/component/${component.key}`}
            target="_blank"
        >
            <div className="parent-component-card-content">
                <img
                    src={iconPath}
                    alt=""
                    className="parent-component-card-icon"
                    onError={(e) => {
                        e.currentTarget.src = "/Images/placeholder.png";
                    }}
                />
                <div className="parent-component-card-info">
                    <h4 className="parent-component-card-name">
                        {component.displayName(building)}
                    </h4>
                    <span className="parent-component-card-type">
                        {getTranslation(component.specificType?.value ?? undefined, component.type)}
                    </span>
                </div>
            </div>
            <ExternalLink size={16} className="parent-component-card-external-icon" />
        </Link>
    );
};

export default ParentComponentCard;
